import { AbstractDocumentItemAlert } from ".";
import { ICompareDateValidatable, IItem } from "../items";

export class CompareDateEmptyAlert extends AbstractDocumentItemAlert<IItem & ICompareDateValidatable> {
  constructor(itemSetId: number, item: IItem & ICompareDateValidatable) {
    super(itemSetId, item, false);
  }

  get kind(): string {
    return "日付比較";
  }

  get target(): string {
    return "日付比較「"
      + (this._detectedItem.name ? this._detectedItem.name : "")
      + "」";
  }

  get description(): string {
    // TODO: 対象の日付オブジェクトの名称を表示したいが、現状では計算式の材料の情報を持ってきていない
    return "日付が取得できないため日付の比較はできません。";
  }
}
